// ============================================================
// AssetGuard — Access Rights
// Range: 9001–9699
//
// FIXES applied vs original:
//   - ASSETGUARD_ASSETS, ASSETGUARD_ASSETS_FILES, ASSETGUARD_ASSETS_LOGS
//     were pointing to Globo's 8101/8104/8105 range — corrected to 9xxx.
//   - All STATICDATA entries were collapsed to 9101 — each now has its own value.
//   - DASHBOARD was also 9101 — corrected to 9001.
// ============================================================

export const ASSETGUARD_ACCESS_RIGHTS = {

  //#region DASHBOARDS
  ASSETGUARD_ADMIN_DASHBOARD: 9101,
  ASSETGUARD_EMPLOYEE_DASHBOARD: 9102,
  ASSETGUARD_MYASSETS: 9103,
  //#endregion

  //#region ASSETS
  ASSETGUARD_ASSETS: 9201,
  ASSETGUARD_ASSETS_FILES: 9202,
  ASSETGUARD_ASSETS_LOGS: 9203,
  //#endregion

  //#region STATIC DATA
  ASSETGUARD_STATICDATA_AGENCIYTRANSFERBASIS: 9501,
  ASSETGUARD_STATICDATA_ASSETARTICLES: 9502,
  ASSETGUARD_STATICDATA_ASSETCONDITIONS: 9503,
  ASSETGUARD_STATICDATA_ASSETGROUPS: 9504,
  ASSETGUARD_STATICDATA_ASSETTYPES: 9505,
  ASSETGUARD_STATICDATA_DISPOSALMETHODS: 9506,
  ASSETGUARD_STATICDATA_DOCUMENTTYPES: 9507,
  ASSETGUARD_STATICDATA_GOVAGENCIES: 9508,
  ASSETGUARD_STATICDATA_GOVDEPARTMENTS: 9509,
  ASSETGUARD_STATICDATA_MAINTENANCETYPES: 9510,
  ASSETGUARD_STATICDATA_RETURNREASONS: 9511,
  ASSETGUARD_STATICDATA_SERVICEPROVIDERS: 9512,
  ASSETGUARD_STATICDATA_STORAGELOCATIONS: 9513,
  ASSETGUARD_STATICDATA_TRANSFERREASONS: 9514,
  ASSETGUARD_STATICDATA_UNITOFMEASURES: 9515,
  //#endregion

  //#region TRANSACTIONS
  ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_VIEWER: 9601,
  ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_REQUESTOR: 9602,
  ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_APPROVER: 9603,
  ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_VIEWER: 9604,
  ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_REQUESTOR: 9605,
  ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_APPROVER: 9606,
  ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_VIEWER: 9607,
  ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_REQUESTOR: 9608,
  ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_APPROVER: 9609,
  ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_VIEWER: 9610,
  ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_REQUESTOR: 9611,
  ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_APPROVER: 9612,
  ASSETGUARD_TRANSACTIONS_ASSETISSUANCES_VIEWER: 9613,
  ASSETGUARD_TRANSACTIONS_ASSETISSUANCES_REQUESTOR: 9614,
  ASSETGUARD_TRANSACTIONS_ASSETISSUANCES_APPROVER: 9615,
  ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_VIEWER: 9616,
  ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_REQUESTOR: 9617,
  ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_APPROVER: 9618,
  ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_VIEWER: 9619,
  ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_REQUESTOR: 9620,
  ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_APPROVER: 9621,
  ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_VIEWER: 9622,
  ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_REQUESTOR: 9623,
  ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_APPROVER: 9624,
  ASSETGUARD_TRANSACTIONS_STOLENASSETS_VIEWER: 9625,
  ASSETGUARD_TRANSACTIONS_STOLENASSETS_REQUESTOR: 9626,
  ASSETGUARD_TRANSACTIONS_STOLENASSETS_APPROVER: 9627,
  //#endregion

  //#region REPORTS
  ASSETGUARD_REPORTS: 9801,
  //#endregion

};